import React from "react";
import { Icon } from "@vitalsource/vstui";

const inertSvgProps = {
  // hides the icon from screen readers
  "aria-hidden": true,

  // makes sure the icon doesn't receive focus in ie11
  focusable: false,

  // not sure if this is needed, but would potentially prevent issues
  // in safari around click events grabbing focus (like in vstui menus)
  style: { pointerEvents: "none" }
};

// TODO: why are we using svg's here instead of text?
const _letters = {
  a:
    "M25.2,24.8h-6.5l-1.5,4H16l5.4-14.2h1.1l5.4,14.2h-1.2L25.2,24.8z M19.1,23.8h5.7L22,16.1L19.1,23.8z",
  b:
    "M17.7,28.8V14.6h4.2c1.5,0,2.7,0.3,3.5,0.9c0.8,0.6,1.2,1.6,1.2,2.8c0,0.7-0.2,1.4-0.6,1.9s-0.9,0.9-1.6,1.2c0.8,0.2,1.5,0.6,2,1.2c0.5,0.6,0.8,1.4,0.8,2.2c0,1.3-0.4,2.2-1.2,2.9s-1.9,1.1-3.4,1.1H17.7z M18.9,21h3.3c1,0,1.8-0.3,2.3-0.7c0.5-0.5,0.8-1.1,0.8-2c0-0.9-0.3-1.6-0.9-2c-0.6-0.4-1.4-0.7-2.6-0.7h-3V21z M18.9,22v5.8h3.6c1,0,1.8-0.3,2.4-0.8c0.6-0.5,0.9-1.2,0.9-2.2c0-0.9-0.3-1.6-0.9-2.1c-0.6-0.5-1.4-0.8-2.4-0.8H18.9z",
  c:
    "M27.4,24.4c-0.2,1.5-0.7,2.6-1.6,3.4S23.7,29,22.1,29c-1.1,0-2-0.3-2.8-0.8S17.9,27,17.5,26c-0.4-1-0.7-2.1-0.7-3.3v-1.8c0-1.3,0.2-2.4,0.7-3.4c0.4-1,1.1-1.7,1.9-2.3s1.8-0.8,2.9-0.8c1.5,0,2.7,0.4,3.6,1.2c0.9,0.8,1.4,2,1.5,3.4h-1.2c-0.3-2.4-1.6-3.6-3.9-3.6c-1.3,0-2.3,0.5-3.1,1.4c-0.8,1-1.1,2.3-1.1,4v1.7c0,1.6,0.4,3,1.1,3.9c0.7,1,1.8,1.5,3,1.5c1.3,0,2.2-0.3,2.8-0.9c0.6-0.6,1-1.5,1.2-2.7H27.4z",
  d:
    "M17.2,28.8V14.6h4c1.2,0,2.2,0.3,3.1,0.8c0.9,0.5,1.6,1.3,2.2,2.3s0.8,2.1,0.8,3.4v1.3c0,1.3-0.3,2.4-0.8,3.4c-0.5,1-1.2,1.7-2.2,2.3c-0.9,0.5-2,0.8-3.2,0.8H17.2z M18.4,15.6v12.2h2.7c1.5,0,2.7-0.5,3.6-1.5c0.9-1,1.4-2.3,1.4-4v-1.3c0-1.6-0.4-2.9-1.3-3.9c-0.9-1-2.1-1.5-3.5-1.5H18.4z",
  e: "M26,22h-6.6v5.8H27v1h-8.8V14.6h8.8v1h-7.6V21H26V22z",
  f: "M26,22.2h-6.6v6.7h-1.2V14.6H27v1h-7.6v5.5H26V22.2z",
  g:
    "M27.2,27.2c-0.4,0.6-1.1,1.1-2,1.4s-1.9,0.5-3,0.5c-1.1,0-2.1-0.3-3-0.8s-1.5-1.3-2-2.3s-0.7-2.1-0.7-3.4v-1.8c0-2,0.5-3.5,1.5-4.7s2.3-1.7,4-1.7c1.5,0,2.6,0.4,3.5,1.1c0.9,0.7,1.4,1.8,1.6,3.1H26c-0.2-1-0.6-1.8-1.3-2.4c-0.7-0.5-1.6-0.8-2.6-0.8c-1.3,0-2.4,0.5-3.2,1.4c-0.8,0.9-1.2,2.3-1.2,4v1.7c0,1.1,0.2,2,0.6,2.9s0.9,1.5,1.6,1.9c0.7,0.5,1.5,0.7,2.4,0.7c1,0,1.9-0.2,2.7-0.5c0.5-0.2,0.8-0.5,1.1-0.8v-3.7h-3.8v-1h5V27.2z",
  h: "M27.3,28.8H26V22h-8.1v6.8h-1.2V14.6h1.2V21H26v-6.4h1.2V28.8z",
  i: "M22.6,28.8h-1.2V14.6h1.2V28.8z",
  j:
    "M24.6,14.6h1.2v10c0,1.3-0.4,2.4-1.2,3.2S22.8,29,21.5,29c-1.4,0-2.4-0.4-3.2-1.1s-1.1-1.7-1.1-3h1.2c0,1,0.3,1.8,0.8,2.3s1.3,0.8,2.3,0.8c0.9,0,1.6-0.3,2.2-0.9s0.9-1.4,0.9-2.4V14.6z",
  k:
    "M20.7,21.8l-2,2v5.1h-1.2V14.6h1.2v7.7l7.3-7.7h1.5l-6,6.3l6.4,7.9h-1.5L20.7,21.8z",
  l: "M19.7,27.8h7v1h-8.2V14.6h1.2V27.8z",
  m:
    "M16.7,14.6L22,27.2l5.3-12.5h1.6v14.2h-1.2v-6.2l0.1-6.3l-5.3,12.5h-0.9l-5.3-12.5l0.1,6.3v6.2h-1.2V14.6H16.7z",
  n: "M27.3,28.8h-1.2l-8.2-12.2v12.2h-1.2V14.6h1.2l8.2,12.2V14.6h1.2V28.8z",
  o:
    "M27.5,22.5c0,1.3-0.2,2.5-0.7,3.4c-0.5,1-1.1,1.8-1.9,2.3S23.1,29,22,29c-1.7,0-3-0.6-4-1.8s-1.5-2.8-1.5-4.8V21c0-1.3,0.2-2.4,0.7-3.4s1.1-1.8,1.9-2.3s1.8-0.8,2.9-0.8c1.1,0,2.1,0.3,2.9,0.8c0.8,0.5,1.5,1.3,1.9,2.2c0.5,1,0.7,2.1,0.7,3.3V22.5z M26.3,21c0-1.7-0.4-3.1-1.2-4c-0.8-1-1.8-1.5-3.2-1.5c-1.3,0-2.4,0.5-3.2,1.5s-1.2,2.3-1.2,4.1v1.5c0,1.7,0.4,3,1.2,4S20.7,28,22,28c1.4,0,2.4-0.5,3.2-1.5s1.1-2.3,1.1-4.1V21z",
  p:
    "M18.8,23v5.8h-1.2V14.6h4.8c1.5,0,2.6,0.4,3.5,1.1c0.9,0.8,1.3,1.8,1.3,3.1c0,1.3-0.4,2.4-1.2,3.1c-0.8,0.7-2,1.1-3.6,1.1H18.8z M18.8,22h3.6c1.2,0,2.1-0.3,2.7-0.8c0.6-0.6,0.9-1.3,0.9-2.3c0-1-0.3-1.8-0.9-2.4c-0.6-0.6-1.5-0.9-2.6-0.9h-3.7V22z",
  q:
    "M27.5,22.5c0,1.4-0.2,2.5-0.7,3.5s-1.2,1.8-2,2.3l2.6,2.3l-0.8,0.7l-2.9-2.5C23.1,29,22.5,29,22,29c-1.1,0-2-0.3-2.9-0.8s-1.5-1.3-2-2.3s-0.7-2.1-0.7-3.4V21c0-1.3,0.2-2.4,0.7-3.4s1.1-1.8,1.9-2.3s1.8-0.8,2.9-0.8c1.1,0,2.1,0.3,2.9,0.8s1.5,1.3,1.9,2.3s0.7,2.1,0.7,3.4V22.5z M26.3,21c0-1.7-0.4-3.1-1.2-4c-0.8-1-1.8-1.5-3.2-1.5c-1.3,0-2.4,0.5-3.1,1.5s-1.2,2.3-1.2,4.1v1.5c0,1.7,0.4,3,1.2,4S20.6,28,22,28c1.4,0,2.4-0.5,3.2-1.5c0.8-1,1.2-2.3,1.2-4.1V21z",
  r:
    "M22.8,22.9h-4.1v5.9h-1.2V14.6H22c1.5,0,2.7,0.4,3.6,1.1c0.9,0.7,1.3,1.8,1.3,3.1c0,0.9-0.3,1.7-0.8,2.4c-0.5,0.7-1.2,1.2-2.1,1.4l3.6,6.1v0.1h-1.3L22.8,22.9z M18.6,21.9h3.7c1,0,1.8-0.3,2.4-0.9c0.6-0.6,0.9-1.3,0.9-2.2c0-1-0.3-1.8-1-2.3c-0.6-0.6-1.5-0.8-2.7-0.8h-3.4V21.9z",
  s:
    "M25.9,25.3c0-0.8-0.3-1.4-0.8-1.9c-0.6-0.5-1.6-0.9-3-1.3c-1.5-0.4-2.5-0.9-3.2-1.4c-1-0.7-1.4-1.6-1.4-2.7c0-1.1,0.4-2,1.3-2.7s2-1,3.4-1c0.9,0,1.8,0.2,2.5,0.5c0.7,0.4,1.3,0.9,1.7,1.5s0.6,1.4,0.6,2.2h-1.2c0-1-0.3-1.8-1-2.3s-1.6-0.9-2.7-0.9c-1.1,0-2,0.2-2.6,0.7c-0.6,0.5-1,1.1-1,1.9c0,0.7,0.3,1.3,0.9,1.8c0.6,0.5,1.5,0.9,2.8,1.2c1.3,0.3,2.2,0.7,2.9,1.1c0.7,0.4,1.2,0.8,1.5,1.3s0.5,1.1,0.5,1.8c0,1.1-0.4,2-1.3,2.7c-0.9,0.7-2.1,1-3.5,1c-1,0-1.9-0.2-2.8-0.5S18,27.6,17.6,27s-0.6-1.4-0.6-2.2h1.2c0,1,0.4,1.8,1.1,2.4s1.7,0.9,3,0.9c1.1,0,2-0.2,2.7-0.7C25.6,26.8,25.9,26.2,25.9,25.3z",
  t: "M27.7,15.6h-4.9v13.2h-1.2V15.6h-4.9v-1h10.9V15.6z",
  u:
    "M27,14.6v9.7c0,1-0.2,1.8-0.6,2.5c-0.4,0.7-1,1.3-1.8,1.6C23.9,28.8,23,29,22,29c-1.5,0-2.7-0.4-3.6-1.2S17,25.9,17,24.4v-9.8h1.2v9.6c0,1.2,0.3,2.1,1,2.8s1.6,1,2.8,1c1.2,0,2.1-0.3,2.8-1c0.7-0.7,1-1.6,1-2.8v-9.6H27z",
  v:
    "M21.9,27.1l0.1,0.3l0.1-0.3l4.5-12.5h1.3l-5.3,14.2h-1.2l-5.3-14.2h1.3L21.9,27.1z",
  w:
    "M17.5,25l0.4,2.2l0.5-2.1l3.1-10.5h1.1l3,10.5l0.5,2.1l0.5-2.2l2.6-10.4h1.2l-3.6,14.2h-1.2l-3.2-11.1l-0.4-1.4l-0.4,1.4l-3.3,11.1h-1.2l-3.6-14.2h1.2L17.5,25z",
  x:
    "M22,20.6l4-6h1.4l-4.7,7l4.9,7.2h-1.4L22,22.6l-4.2,6.2h-1.4l4.9-7.2l-4.7-7H18L22,20.6z",
  y: "M22,22.4l4.3-7.8h1.4l-5.1,8.9v5.4h-1.2v-5.4l-5.1-8.9h1.4L22,22.4z",
  z: "M18.4,27.8h8.8v1H16.9v-0.9l8.4-12.3h-8.2v-1h9.7v0.9L18.4,27.8z"
};

// TODO: The sizing of these icons isn't uniform. Some have set dimensions, and
// others don't.
// TODO: This should define required (or conditionally required) props, to
// prevent invalid prop combinations.
export default ({
  customIcon,
  icon,
  letter,
  fill = "#eb710b",
  imgStyle,
  height,
  width,
  ...props
}) => {
  switch (icon) {
    case "reader":
      return (
        <Icon
          x="0px"
          y="0px"
          width={width}
          height={height}
          enableBackground={`new 0 0 ${width} ${height}`}
          xmlSpace="preserve"
          {...inertSvgProps}
        >
          <g>
            <g>
              <g>
                <g>
                  <circle
                    className="background"
                    fill={fill}
                    cx="22"
                    cy="22"
                    r="22"
                  />
                </g>
              </g>
              <g>
                <path
                  fill="#FFFFFF"
                  d="M31,10.2H13c-1.1,0-2,0.9-2,2v20c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2v-20C33,11.1,32.1,10.2,31,10.2z
				 M16,32.1h-3v-20h3V32.1z M30,30.6c0,0.8-0.7,1.5-1.5,1.5h-8c-0.8,0-1.5-0.7-1.5-1.5v-1c0-0.8,0.7-1.5,1.5-1.5h8
				c0.8,0,1.5,0.7,1.5,1.5V30.6z M30,24.2H19v-2h11V24.2z M30,20.2H19v-2h11V20.2z M30,16.2H19v-2h11V16.2z"
                />
              </g>
            </g>
          </g>
        </Icon>
      );

    case "arrow":
      return (
        <Icon
          x="0px"
          y="0px"
          width={width}
          height={height}
          style={{ enableBackground: `new 0 0 ${width} ${height}` }}
          xmlSpace="preserve"
          {...inertSvgProps}
        >
          <g>
            <g>
              <circle
                className="background"
                fill={fill}
                cx="22"
                cy="22.1"
                r="22"
              />
            </g>
          </g>
          <path
            className="st1"
            fill="#FFFFFF"
            d="M32.4,20.2l-9.3-8.3v5.3c-0.8,0-1.8,0-2.9,0c-4.5,0-7.8,2-8.5,7.1c-0.6,4.9,1.9,7.9,1.9,7.9s-0.4-4.4,1.3-6.9
	c1.3-1.9,3.1-2,8.1-2v5.3L32.4,20.2z"
          />
        </Icon>
      );
    case "mobile":
      return (
        <svg
          x="0px"
          y="0px"
          width={width}
          height={height}
          style={{ enableBackground: `new 0 0 ${width} ${height}` }}
          xmlSpace="preserve"
          {...inertSvgProps}
        >
          <g>
            <g>
              <circle
                className="background"
                fill={fill}
                cx="22"
                cy="22"
                r="22"
              />
            </g>
          </g>
          <g>
            <path
              className="background"
              fill={fill}
              d="M26.7,12h-9.4c-0.7,0-1.3,0.6-1.3,1.3v13.4c0,0.7,0.6,1.3,1.3,1.3h9.4c0.7,0,1.3-0.6,1.3-1.3V13.3
    C28,12.6,27.4,12,26.7,12z"
            />
            <path
              className="foreground"
              fill="#FFFFFF"
              d="M28.8,10H15.2c-0.7,0-1.2,0.6-1.2,1.2v21.5c0,0.7,0.6,1.2,1.2,1.2h13.5c0.7,0,1.2-0.6,1.2-1.2V11.2
    C30,10.6,29.4,10,28.8,10z M25.5,31.5h-7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h7c0.3,0,0.5,0.2,0.5,0.5
    C26,31.3,25.8,31.5,25.5,31.5z M28,26.7c0,0.7-0.6,1.3-1.3,1.3h-9.4c-0.7,0-1.3-0.6-1.3-1.3V13.3c0-0.7,0.6-1.3,1.3-1.3h9.4
    c0.7,0,1.3,0.6,1.3,1.3V26.7z"
            />
          </g>
        </svg>
      );
    case "custom":
      // custom icons should be decorative and require a label,
      // which is why we're using alt=""
      return (
        <img alt="" src={customIcon} style={{ height, width, ...imgStyle }} />
      );
    default:
      return (
        <svg
          x="0px"
          y="0px"
          width={width}
          height={height}
          style={{ enableBackground: `new 0 0 ${width} ${height}` }}
          xmlSpace="preserve"
          {...props}
          {...inertSvgProps}
        >
          <circle className="background" cx="22" cy="22" r="22" fill={fill} />
          <g fill="white">
            <path d={_letters[letter]} />
          </g>
        </svg>
      );
  }
};

export const PlaceHolder = ({ height = 60, width = 44 }) => (
  <svg width={width} height={height} {...inertSvgProps}>
    <defs />
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g className="background" fill="#ECECEC">
        <g>
          <path d="M22,44 C34.1502645,44 44,34.1502645 44,22 C44,9.8497355 34.1502645,0 22,0 C9.8497355,0 0,9.8497355 0,22 C0,34.1502645 9.8497355,44 22,44 Z" />
          <rect x="3" y="52" width="38" height="8" />
        </g>
      </g>
    </g>
  </svg>
);
